export default __webpack_public_path__ + "static/media/post-logo.dee24df9.svg";